"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findCodeAddress = exports.initAutocomplete = exports.formatNumber = exports.goToStep = exports.applyIFrameCheck = exports.getUrlVariables = void 0;
const _ = __importStar(require("lodash"));
const jquery_1 = __importDefault(require("jquery"));
const config_1 = require("./config");
/**
 * Extracts URL parameters from the current window location.
 *
 * @returns An object where each key is a parameter name and its value is the decoded parameter value.
 */
function getUrlVariables() {
    const urlParams = {};
    const href = window.location.href.split('#')[0];
    href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (match, name, value) => {
        urlParams[name] = decodeURIComponent(value);
        return '';
    });
    return urlParams;
}
exports.getUrlVariables = getUrlVariables;
/**
 * Checks if the current window is inside an iframe and hides the header if it is.
 */
function applyIFrameCheck() {
    if (window.self !== window.top) {
        // Hide the header element if inside an iframe.
        const header = document.getElementById('header');
        if (header) {
            header.style.display = 'none';
        }
    }
}
exports.applyIFrameCheck = applyIFrameCheck;
/**
 * Navigates to a specific step in a multi-step form.
 *
 * This function:
 * - Hides all elements with the class "step".
 * - Updates the browser's history with the current step.
 * - Displays the element with the ID corresponding to the provided step.
 * - If the step is 1, shows the header element.
 *
 * @param step - The step number to navigate to.
 */
function goToStep(step) {
    // Hide all elements with class "step"
    const steps = document.getElementsByClassName('step');
    for (let i = 0; i < steps.length; i++) {
        steps[i].style.display = 'none';
    }
    // Update the URL hash to reflect the current step
    history.pushState(null, '', '#step' + step);
    // Display the selected step if it exists
    const stepElement = document.getElementById('step' + step);
    if (stepElement) {
        stepElement.style.display = 'block';
    }
    // If step is 1, display the header element
    if (step === 1) {
        const header = document.getElementById('header');
        if (header) {
            header.style.display = 'block';
        }
    }
}
exports.goToStep = goToStep;
/**
 * Formats a number with thousand separators and a comma as the decimal separator.
 *
 * If the value is a number, it will be formatted using toFixed with the provided decimals.
 * If the value is a string, it is first parsed to a number and then formatted.
 *
 * @param value - The number or string to format.
 * @param decimals - The number of decimal places to display (default is 2).
 * @returns The formatted number as a string.
 */
function formatNumber(value, decimals = 2) {
    let numericString;
    if (typeof value === 'number') {
        numericString = value.toFixed(decimals);
    }
    else if (typeof value === 'string') {
        // Parse the string to a number and format it
        numericString = parseFloat(value).toFixed(decimals);
    }
    else {
        return String(value);
    }
    // Split the formatted string into integer and decimal parts
    const [integerPart, decimalPart] = numericString.split('.');
    // Add thousand separators to the integer part
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    // Return the formatted number with a comma as the decimal separator
    return decimalPart !== undefined ? `${formattedInteger},${decimalPart}` : formattedInteger;
}
exports.formatNumber = formatNumber;
/**
 * Inicializa el autocompletado de Google Maps para el campo de dirección
 */
function initAutocomplete(formInstance) {
    const input = document.getElementById('pac-input');
    const options = {
        componentRestrictions: { country: config_1.config.context.regionAutocomplete }
    };
    const autocomplete = new google.maps.places.Autocomplete(input, options);
    // Limpiar la dirección guardada cuando el usuario escribe
    input.addEventListener('input', () => {
        if (formInstance) {
            if (formInstance.updateAddressState) {
                formInstance.updateAddressState(false, null);
            }
            else {
                formInstance.addressPlace = null;
                formInstance.addressSelected = false;
            }
            // Remover mensajes de error previos (buscar en siblings del input y del contenedor padre)
            (0, jquery_1.default)(input).siblings('.invalid-feedback').remove();
            (0, jquery_1.default)(input).closest('.d-flex').siblings('.invalid-feedback').remove();
        }
    });
    // Prevenir que el usuario pegue texto sin seleccionar del autocompletado
    input.addEventListener('blur', () => {
        if (formInstance && !formInstance.addressSelected) {
            // Si no se seleccionó una dirección, limpiar el campo
            if (input.value && !formInstance.addressPlace) {
                input.classList.add('is-invalid');
            }
        }
    });
    autocomplete.addListener('place_changed', () => {
        const places = autocomplete.getPlace();
        if (!places.geometry) {
            if (formInstance) {
                if (formInstance.updateAddressState) {
                    formInstance.updateAddressState(false, null);
                }
                else {
                    formInstance.addressPlace = null;
                    formInstance.addressSelected = false;
                }
            }
            return;
        }
        if (formInstance) {
            // Actualizar estado usando el método del controlador si existe
            if (formInstance.updateAddressState) {
                formInstance.updateAddressState(true, places);
            }
            else {
                formInstance.addressPlace = places;
                formInstance.addressSelected = true;
            }
            // Usar un pequeño delay para asegurar que el estado se actualiza antes de validar
            setTimeout(() => {
                input.classList.remove('is-invalid');
                // Forzar revalidación del campo usando jQuery
                const $input = (0, jquery_1.default)(input);
                // Remover cualquier mensaje de error previo (buscar en siblings del input y del contenedor padre)
                $input.siblings('.invalid-feedback').remove();
                $input.closest('.d-flex').siblings('.invalid-feedback').remove();
                $input.removeClass('is-invalid');
                // Disparar validación para actualizar el estado visual
                if ($input.valid()) {
                    $input.addClass('is-valid');
                }
            }, 100);
        }
    });
}
exports.initAutocomplete = initAutocomplete;
/**
 * Busca un componente de dirección en el array de address_components de Google Maps
 * @param array - Array de componentes de dirección de Google Maps
 * @param code - Código del tipo de componente a buscar (ej: 'locality', 'postal_code')
 * @returns El nombre largo del componente encontrado o null si no existe
 */
function findCodeAddress(array, code) {
    const data = _.find(array, (item) => {
        return _.findIndex(item.types, (type) => type === code) !== -1;
    });
    return data ? data.long_name : null;
}
exports.findCodeAddress = findCodeAddress;
